import React, { createRef, PureComponent } from 'react'
import PropTypes from 'prop-types'
import Dropzone from 'react-dropzone'

import SpinnerOverlay from '../spinnerOverlay/SpinnerOverlay'
import './UploadFile.scss'
import { uploadFile } from '../../js/rest'
import { sendExceptionToSentry } from '../../js/sentry'
import Modal from '../app/customModal/Modal'

export default class UploadFile extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      selectedFile: undefined,
      incompatibleUploadFile: false,
      isUploading: false,
      error: undefined,
      uploadSuccess: false
    }
  }

  static propTypes = {
    url: PropTypes.string.isRequired,
    description: PropTypes.object,
    formField: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    authToken: PropTypes.string.isRequired,
    customFetch: PropTypes.func.isRequired,
    fileType: PropTypes.string
  }

  dropzoneRef = createRef()

  render() {
    if (this.state.uploadSuccess) {
      return (
        <div className="upload-excel-content-wrapper">
          <Modal.Content>
            <i className="fa fa-check-circle-o success-mark" aria-hidden="true" />
            <span className="success-message">File was successfully uploaded</span>
          </Modal.Content>
          <Modal.Buttons>
            <div className="btn" onClick={this.props.onClose}>
              Close
            </div>
          </Modal.Buttons>
        </div>
      )
    }

    return (
      <>
        <Modal.Content>
          {this.state.error ? (
            <div className="upload-excel-wrapper">
              <i className="fa fa-frown-o failure-mark" aria-hidden="true" />
              <span className="error-message">
                Failed to upload the file. {this.state.error.message || this.state.error.toString()}
              </span>
            </div>
          ) : undefined}

          <SpinnerOverlay loading={this.state.isUploading} />

          <div className="description">{this.props.description}</div>

          <div className="dropzone-wrapper">
            {/* 
            // @ts-ignore */}
            <Dropzone accept={this.props.fileType} ref={this.dropzoneRef} onDrop={this.onFileDrop}>
              {({ getRootProps, getInputProps }) => (
                <div {...getRootProps()} className="planning-upload-dropzone">
                  {this.renderDropZoneContents(this.state.selectedFile, this.state.incompatibleUploadFile)}
                  <input {...getInputProps()} />
                </div>
              )}
            </Dropzone>
          </div>
        </Modal.Content>
        <Modal.Buttons>
          <div
            className={
              'btn ' +
              (this.state.selectedFile && !this.state.incompatibleUploadFile ? 'upload-btn' : 'upload-btn inactive')
            }
            onClick={async () => {
              if (this.state.selectedFile && !this.state.incompatibleUploadFile) {
                await this.handleUpload()
              }
            }}
          >
            Upload
          </div>
        </Modal.Buttons>
      </>
    )
  }

  handleUpload = async () => {
    await this.setState({
      error: undefined,
      isUploading: true,
      uploadSuccess: false
    })

    try {
      await uploadFile(
        this.props.url,
        this.props.formField,
        this.state.selectedFile,
        this.props.authToken,
        this.props.customFetch
      )

      this.setState({
        isUploading: false,
        uploadSuccess: true
      })
    } catch (err) {
      if (err.status !== 401) {
        sendExceptionToSentry(err)
      } // Not calling handleFetchError because it will trigger the toast, this component has a different error handling

      await this.setState({
        error: err,
        isUploading: false
      })
    }
  }

  /**
   * Render the inner contents of the dropzone square
   * @param {any} selectedFileForUpload
   * @param {any} incompatibleUploadFile
   * @returns {any}
   */
  renderDropZoneContents = (selectedFileForUpload, incompatibleUploadFile) => {
    if (incompatibleUploadFile) {
      return (
        <div className="dropzone-contents">
          <span className="error">Incompatible file selected</span>
        </div>
      )
    } else if (!selectedFileForUpload && !incompatibleUploadFile) {
      return (
        <div className="dropzone-contents">
          <span className="placeholder">
            Drop a {this.props.fileType} file here, or click here to select a file from your computer
          </span>
        </div>
      )
    } else if (selectedFileForUpload && !incompatibleUploadFile) {
      return (
        <div className="dropzone-contents">
          <div className="dropzone-selected-file">
            <span className="title">Selected file:</span>
            <span className="filename">{selectedFileForUpload.name}</span>
          </div>
        </div>
      )
    }
    return null
  }

  /**
   * Function that is called when user drops / selects an file to upload
   */
  onFileDrop = (accepted, rejected) => {
    if (accepted && accepted[0]) {
      this.setState({
        incompatibleUploadFile: false,
        selectedFile: accepted[0]
      })
    } else if (rejected) {
      this.setState({
        incompatibleUploadFile: true,
        selectedFile: undefined
      })
    }
  }
}
